export enum GoodTransactionType {
Purchase,
Sale,
Internal,
PhysicalInventory,
}
